module.exports = __webpack_public_path__ + "static/media/step-2-throat-swab.8de52b6d.svg";